import { useTranslation } from 'react-i18next';
import styled from 'styled-components/native';

import { GET_LAYOUT_MAX_WIDTH } from '../../constants/layout';
import Banner from '../../elements/Banner';
import { VendorBanner } from '../../types/VendorDetail';

const BANNER_MAX_WIDTH = 768;
const BANNER_RATIO = 180 / 375;
const GET_BANNER_WIDTH = () =>
  Math.min(GET_LAYOUT_MAX_WIDTH(), BANNER_MAX_WIDTH);
const GET_BANNER_HEIGHT = () => GET_BANNER_WIDTH() * BANNER_RATIO;

type Props = {
  eventBanner: VendorBanner;
  isFetching: boolean;
};

const EventBanner = ({ eventBanner, isFetching }: Props) => {
  const { t } = useTranslation();

  return (
    <S.EventBannerWrapper>
      <S.EventBannerTitle>{t('vendor-event-banner')}</S.EventBannerTitle>
      <Banner
        sources={{
          1: { uri: eventBanner.sm },
          2: { uri: eventBanner.md },
          3: { uri: eventBanner.lg },
        }}
        bannerStyle={eventBannerStyle}
        isFetching={isFetching}
      />
    </S.EventBannerWrapper>
  );
};

export default EventBanner;

const S = {
  EventBannerWrapper: styled.View`
    background-color: ${({ theme }) => theme.palette.white};
  `,
  EventBannerTitle: styled.Text`
    margin: 12px 16px;
    font-size: 15px;
    font-weight: bold;
    color: ${({ theme }) => theme.palette.warrior};
  `,
};

const eventBannerStyle = {
  margin: 'auto',
  height: GET_BANNER_HEIGHT(),
  width: GET_BANNER_WIDTH(),
};
